<div
	*ngIf="Data?.status == 3"
	class="mb-24px max-w-[872px] rounded-12px m-auto max-mobile:px-padding-mobile-14"
>
	<div class="flex items-center justify-between">
		<div>
			<app-status [enumData]="status" [statusValue]="Data?.status"></app-status>
			<p
				class="text-font-16 ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey px-[6px] m-0"
			>
				{{ Data?.businessName }}
			</p>
		</div>
		<button
			(click)="openDialog('ACCEPT')"
			class="bg-gradient text-font-14 text-off-white rounded-[5px] py-[10px] px-24px"
		>
			{{ 'ACTIONS.ACCEPT' | translate }}
		</button>
	</div>
</div>
<form
	class="bg-off-white py-36px px-[48px] max-w-[872px] rounded-12px m-auto max-mobile:px-padding-mobile-14"
>
	<!-- ADMIN INFO -->

	<p
		class="ltr:font-DIN-Bold font-bold rtl:font-medium text-font-16 text-main-color-black mb-12px"
	>
		{{ 'ORGANIZATION.ORGANIZATION_STATUS.ADMIN_INFO' | translate }}
	</p>
	<div
		class="bg-off-white px-24px py-[16px] rounded-12px mb-24px shadow-[0_5px_15px_-3px_rgba(110,113,145,0.16)]"
	>
		<div class="w-full h-[73px] p-[16px] border-solid border-b-2">
			<p class="mb-0 text-font-14 pb-0 text-[#4E4B66]">
				{{ 'GENERAL_LABELS.FIRST_NAME' | translate }}
			</p>
			<p class="viewMode text-[#6E7191] text-font-16">{{ Data?.firstName }}</p>
		</div>
		<div class="w-full h-[73px] p-[17px] border-solid border-b-2">
			<p class="mb-0 pb-0 text-[#4E4B66] text-font-14">
				{{ 'GENERAL_LABELS.LAST_NAME' | translate }}
			</p>
			<p class="viewMode text-[#6E7191] text-font-16">{{ Data?.lastName }}</p>
		</div>
		<div
			*ngIf="Data?.email"
			class="w-full h-[73px] p-[17px] border-solid border-b-2"
		>
			<p class="mb-0 pb-0 text-[#4E4B66] text-font-14">
				{{ 'GENERAL_LABELS.EMAIL' | translate }}
			</p>
			<p class="viewMode text-[#6E7191] text-font-16">{{ Data?.email }}</p>
		</div>
		<div class="w-full h-[73px] p-[17px] border-solid">
			<p class="mb-0 pb-0 text-[#4E4B66] text-font-14">
				{{ 'GENERAL_LABELS.PHONE' | translate }}
			</p>
			<p class="viewMode text-[#6E7191] text-font-16">
				{{ Data?.mobileNumber }}
			</p>
		</div>
	</div>
	<!-- ADMIN INFO -->

	<!-- ORGANIZATION INFORMATION -->

	<p
		class="ltr:font-DIN-Bold font-bold rtl:font-medium text-font-16 text-main-color-black mb-12px"
	>
		{{ 'ORGANIZATION.ORGANIZATION_STATUS.ORG_INFO' | translate }}
	</p>
	<div
		class="bg-off-white p-[16px] rounded-12 mb-24px shadow-[0_5px_15px_-3px_rgba(110,113,145,0.16)]"
	>
		<div class="w-full h-[73px] py-12px px-[17px] border-solid border-b-2">
			<p class="mb-0 pb-0 text-[#4E4B66] text-font-14">
				{{ 'GENERAL_LABELS.COUNTRY' | translate }}
			</p>
			<p class="viewMode text-[#6E7191] text-font-16">
				{{
					currentLang == 'en'
						? Data?.country?.name?.en
						: Data?.country?.name?.ar
				}}
			</p>
		</div>
		<div class="w-full h-[73px] py-12px px-[17px] border-solid border-b-2">
			<p class="mb-0 pb-0 text-[#4E4B66] text-font-14">
				{{ 'ORGANIZATION.ORGANIZATION_STATUS.BUSINESS_NAME' | translate }}
			</p>
			<p class="viewMode text-[#6E7191] text-font-16">
				{{ Data?.businessName }}
			</p>
		</div>

		<div class="w-full h-[73px] py-12px px-[17px] border-solid">
			<p class="mb-0 pb-0 text-[#4E4B66] text-font-14">
				{{ 'ORGANIZATION.ORGANIZATION_STATUS.BUSINESS_TYPE' | translate }}
			</p>
			<p class="viewMode text-[#6E7191] text-font-16">
				{{ currentLang == 'en' ? Data?.type?.name?.en : Data?.type?.name?.ar }}
			</p>
		</div>

		<!-- Target Audience -->

		<!-- TARGET AUDIENCE -->
		<!-- <div class="mb-24px">
			<p
				class="text-dark-grey ltr:font-DIN-Bold font-bold rtl:font-medium text-font-16 mb-24px"
			>
				{{ 'ORGANIZATION.ORGANIZATION_STATUS.TARGET_AUDIENCE' | translate }}
			</p>
			<mat-checkbox
				*ngFor="let targetaudience of Data?.targetAudience; let i = index"
				class="opacity-50 text-font-14 rtl:mr-24px ltr:ml-24px"
				[disabled]="true"
				[checked]="true"
			>
				{{
					'ORGANIZATION.BRANCH.' +
						BranchTypes[targetaudience]?.name.toUpperCase() | translate
				}}

			</mat-checkbox>
		</div> -->
		<!-- TARGET AUDIENCE -->

		<mat-form-field
			*ngIf="Data?.commercialRegistration"
			[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
			appearance="outline"
			class="w-full mb-[8px]"
			floatLabel="always"
		>
			<mat-label class="text-font-12 text-main-color-black opacity-100">{{
				'ORGANIZATION.ORGANIZATION_STATUS.COMMERCIAL_REGISTRATION' | translate
			}}</mat-label>
			<input
				[disabled]="true"
				[value]="Data?.commercialRegistration"
				class="text-dark-grey"
				matInput
				required
				type="text"
				value="15"
			/>
		</mat-form-field>
		<mat-form-field
			*ngIf="Data?.maroofNumber"
			[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
			appearance="outline"
			class="w-full mb-[8px]"
			floatLabel="always"
		>
			<mat-label class="text-font-12 text-main-color-black opacity-100">{{
				'GENERAL_LABELS.MAROOF_NUMBER' | translate
			}}</mat-label>
			<input
				[disabled]="true"
				[value]="Data?.maroofNumber"
				class="text-dark-grey"
				matInput
				required
				type="text"
				value="15"
			/>
		</mat-form-field>
	</div>

	<p
		class="ltr:font-DIN-Bold font-bold rtl:font-medium text-font-16 text-main-color-black mb-12px"
	>
		{{ 'ORGANIZATION.ORGANIZATION_STATUS.TARGET_AUDIENCE' | translate }}
	</p>
	<div
		class="bg-off-white p-[16px] rounded-12 mb-24px shadow-[0_5px_15px_-3px_rgba(110,113,145,0.16)]"
	>
		<div class="grid mobile:grid-cols-2 smMobile:grid-cols-1">
			<ng-container *ngFor="let Target of BranchTypes">
				<div>
					<div
						class="flex-col mx-[6px] my-1 text-font-16 text-[#1C252E] py-[20px] px-[20px] border-[2px] rounded-6px max-w-[350px]"
					>
						<div>
							<img [src]="Target['icon']" class="m-auto mb-[6px]" />
							<p class="text-center">
								{{ 'SCHEMA.TARGET_AUDIENCE.' + Target['name'] | translate }}
							</p>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
	<!-- social media -->
	<p
		class="ltr:font-DIN-Bold font-bold rtl:font-medium text-font-16 text-main-color-black mb-12px"
	>
		{{ 'ORGANIZATION.BRANCH.SOCIAL_MEDIA_ACCOUNTS' | translate }}
	</p>
	<div
		class="flex flex-col custom-shadow mb-8 p-24px gap-[14px] rounded-12px bg-off-white lg:w-[776px]"
	>
		<div class="w-full h-[73px] p-[17px] border-solid border-b-2">
			<div class="flex gap-2">
				<img
					class="w-[24px] h-[24px] mt-2"
					src="assets/images/instagram-svgrepo-com.svg"
					alt=""
				/>
				<div>
					<p class="mb-0 pb-0 text-[#6E7191] text-font-14">
						{{ 'ORGANIZATION.BRANCH.INSTAGRAM' | translate }}
					</p>
					<p class="text-dark-grey text-font-16">HIUH</p>
				</div>
			</div>
		</div>
		<div class="w-full h-[73px] p-[17px]">
			<div class="flex gap-3">
				<img
					class="w-[24px] h-[24px] mt-2"
					src="assets/images/facebook-svgrepo.svg"
					alt=""
				/>
				<div>
					<p class="mb-0 pb-0 text-[#6E7191] text-font-14">
						{{ 'ORGANIZATION.BRANCH.FACEBOOK' | translate }}
					</p>
					<p class="text-dark-grey text-font-16">HIUH</p>
				</div>
			</div>
		</div>
	</div>
	<!-- ORGANIZATION INFORMATION -->

	<button
		(click)="openDialog('ACCEPT')"
		*ngIf="Data?.status !== 3"
		class="bg-gradient text-font-14 text-off-white rounded-[5px] w-full py-[10px] mb-[8px]"
	>
		{{ 'ACTIONS.ACCEPT' | translate }}
	</button>
	<button
		(click)="openDialog('REJECT')"
		*ngIf="Data?.status !== 3"
		class="bg-transparent text-font-14 border-solid border-[1px] secondry-color-Gray rounded-[5px] w-full py-[10px]"
	>
		{{ 'ACTIONS.REJECT' | translate }}
	</button>
</form>
